/* ==========================================================================
   PARROTTY — Announcement bar continuous marquee (mobile only)
   Reads whatever announcement text(s) Dawn already rendered, combines
   them, duplicates the combined string, and replaces the announcement
   bar's inner content with a continuously-scrolling track. This removes
   Dawn's slide-transition behavior entirely on mobile in favor of one
   smooth, uninterrupted scroll — works whether there's 1 or many
   announcement blocks configured in the theme editor.
   ========================================================================== */

(function () {
  function initMarquee() {
    if (window.matchMedia && !window.matchMedia('(max-width: 749px)').matches) return;

    var bar = document.querySelector('.utility-bar .announcement-bar');
    if (!bar || bar.dataset.nuraMarqueeInit === 'true') return;

    var messageEls = bar.querySelectorAll('.announcement-bar__message span');
    if (!messageEls.length) return;

    var text = Array.prototype.map
      .call(messageEls, function (el) { return el.textContent.trim(); })
      .filter(Boolean)
      .join('   •   ');

    if (!text) return;

    bar.dataset.nuraMarqueeInit = 'true';

    var wrap = document.createElement('div');
    wrap.className = 'nura-marquee-wrap';

    var track = document.createElement('div');
    track.className = 'nura-marquee-track';

    var span1 = document.createElement('span');
    span1.textContent = text;
    var span2 = document.createElement('span');
    span2.textContent = text;
    span2.setAttribute('aria-hidden', 'true');

    track.appendChild(span1);
    track.appendChild(span2);
    wrap.appendChild(track);

    bar.innerHTML = '';
    bar.appendChild(wrap);
  }

  document.addEventListener('DOMContentLoaded', initMarquee);
})();
